import React from 'react';
import { Button } from '@/components/ui';
import { Plus } from 'lucide-react';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function ButtonsSection() {
  return (
    <SectionWrapper title="Buttons">
        {/* Variants */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Variants</h3>
          <div className="flex flex-wrap gap-3">
            <Button variant="primary">Primary</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="accent">Accent</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="dashed" leftIcon={<Plus className="w-4 h-4" />}>Dashed</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="link">Link</Button>
            <Button variant="danger">Danger</Button>
          </div>
          <CodeBlock>
{`<Button variant="primary">Primary</Button>
<Button variant="secondary">Secondary</Button>
<Button variant="accent">Accent</Button>
<Button variant="outline">Outline</Button>
<Button variant="dashed" leftIcon={<Plus />}>Dashed</Button>
<Button variant="ghost">Ghost</Button>
<Button variant="link">Link</Button>
<Button variant="danger">Danger</Button>`}
          </CodeBlock>
        </div>

        {/* Dashed Border Special Use Case */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Dashed Border Button</h3>
          <p className="text-sm text-muted-foreground mb-4">
            The dashed variant is ideal for "add" actions or placeholder buttons that invite user interaction.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button variant="dashed" leftIcon={<Plus className="w-4 h-4" />}>Add Item</Button>
            <Button variant="dashed" leftIcon={<Plus className="w-4 h-4" />} size="sm">Add Tag</Button>
            <Button variant="dashed" leftIcon={<Plus className="w-4 h-4" />} size="lg">Add Destination</Button>
          </div>
          <CodeBlock>
{`// Common use cases for dashed buttons:
<Button variant="dashed" leftIcon={<Plus />}>Add Item</Button>
<Button variant="dashed" leftIcon={<Plus />} size="sm">Add Tag</Button>

// Works well alongside tabs or chip-style buttons
<Button variant="outline">Paris</Button>
<Button variant="outline">London</Button>
<Button variant="dashed" leftIcon={<Plus />}>Add Destination</Button>`}
          </CodeBlock>
        </div>

        {/* Sizes */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Sizes</h3>
          <div className="flex items-center gap-3">
            <Button size="sm">Small</Button>
            <Button size="md">Medium</Button>
            <Button size="lg">Large</Button>
            <Button size="icon">
              <Plus className="w-4 h-4" />
            </Button>
          </div>
          <CodeBlock>
{`<Button size="sm">Small</Button>
<Button size="md">Medium</Button>
<Button size="lg">Large</Button>
<Button size="icon">
  <PlusIcon className="w-4 h-4" />
</Button>`}
          </CodeBlock>
        </div>

        {/* States */}
        <div>
          <h3 className="text-lg font-semibold mb-4">States</h3>
          <div className="flex gap-3">
            <Button disabled>Disabled</Button>
            <Button loading>Loading</Button>
            <Button variant="primary" icon={<span className="text-lg">🚀</span>}>
              With Icon
            </Button>
          </div>
          <CodeBlock>
{`<Button disabled>Disabled</Button>
<Button loading>Loading</Button>
<Button variant="primary" icon={<RocketIcon />}>
  With Icon
</Button>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
